import React from "react";

import {
    Container,
    Row,
    Col,
    Button,
    Badge,
    NavLink,
    DropdownToggle,
    Media,
    DropdownMenu,
    DropdownItem, UncontrolledDropdown
} from "reactstrap";
import businessHelper from "../../helpers/BusinessHelper";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {common_strings} from "../../translations/common_translations";
import {Link} from "react-router-dom";
import {isMobile} from 'react-device-detect';
import roomSvg from "assets/img/icons/common/room_white.svg"
import ticketSvg from "assets/img/icons/common/ticket_white.svg"
import editSvg from "assets/img/icons/common/edit_white.svg"

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

class UserHeader extends React.Component {

    state = {
        business: this.props.business,
        curUser: businessHelper.subUser(),
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.business !== this.state.business) {
            this.setState({business: nextProps.business})
        }
    }

    showClassTypes(e) {
        e.preventDefault();
        this.props.showClassTypes();
    }

    showTicketTypes(e) {
        e.preventDefault();
        this.props.showTicketTypes();
    }

    showTeachers(e) {
        e.preventDefault();
        this.props.showTeachers();
    }

    showRooms(e) {
        e.preventDefault();
        this.props.showRooms();
    }

    editProfile(e) {
        e.preventDefault();
        this.props.editProfile();
    }

    render() {
        this.localize();

        let back = (this.state.business && this.state.business.photo) ? "url(" + this.state.business.photo + ")" : "url(" + require("assets/img/theme/yoga-background.jpg") + ")";

        return (
            <>
                <div
                    className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                    style={{
                        minHeight: "600px",
                        backgroundImage: back,
                        backgroundSize: "cover",
                        backgroundPosition: "center top"
                    }}
                >
                    {/* Mask */}
                    <span className="mask bg-gradient-dark opacity-8"/>
                    {/* Header container */}
                    <Container className="d-flex align-items-center" fluid>
                        <Row>
                            <Col lg="12" md="10">
                                <h1 className="display-2 text-white">{this.state.business.name}</h1>
                                <p className="text-white mt-0 mb-5">
                                    {this.state.business.description ? this.state.business.description.substring(0, 400) : ""}
                                    {/*This is your profile page. You can see the progress you've*/}
                                    {/*made with your work and manage your projects or assigned tasks*/}
                                </p>
                                {/*<Button*/}
                                {/*    color="info"*/}
                                {/*    href="#pablo"*/}
                                {/*    onClick={e => e.preventDefault()}*/}
                                {/*>*/}
                                {/*    Edit profile*/}
                                {/*</Button>*/}
                            </Col>

                            {/*WEB CONTROLS*/}
                            {!isMobile &&
                            <Row>
                                <Col lg="12" style={{marginLeft: 20}}>
                                    <Button
                                        color="danger"
                                        className="mt-2"
                                        onClick={e => this.showClassTypes(e)}
                                    >
                                <span className="d-none d-md-block">
                                <img
                                    style={{marginRight: '0.5rem'}}
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={businessHelper.classIcon()}
                                /> {resourceStrings.class_types}
                                </span>
                                        <span className="d-md-none">
                                <img
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={businessHelper.classIcon()}
                                /></span>
                                    </Button>
                                    <Button
                                        color="warning"
                                        className="mt-2"
                                        onClick={e => this.showTicketTypes(e)}
                                    >
                                <span className="d-none d-md-block">
                                <img
                                    style={{marginRight: '0.5rem'}}
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={require("assets/img/icons/common/ticket_white.svg").default}
                                /> {resourceStrings.ticket_types}
                                </span>
                                        <span className="d-md-none">
                                <img
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={ticketSvg}
                                /></span>
                                    </Button>
                                    <Button
                                        color="success"
                                        className="mt-2"
                                        onClick={e => this.showTeachers(e)}
                                    >
                                <span className="d-none d-md-block">
                                <img
                                    style={{marginRight: '0.5rem'}}
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={businessHelper.teacherIcon()}
                                /> {resourceStrings.teachers}
                                </span>
                                        <span className="d-md-none">
                                <img
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={businessHelper.teacherIcon()}
                                /></span>
                                    </Button>
                                    <Button
                                        color="info"
                                        className="mt-2"
                                        onClick={e => this.showRooms(e)}
                                    >
                                <span className="d-none d-md-block">

                                    <img
                                    style={{marginRight: '0.5rem'}}
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={roomSvg}
                                /> {resourceStrings.rooms}
                                </span>
                                        <span className="d-md-none">
                                <img
                                    width={24}
                                    height={24}
                                    alt="pm"
                                    src={roomSvg}
                                /></span>
                                    </Button>

                                    {this.props.showEditButton === true &&
                                    <Button
                                        className="mt-2"
                                        color="danger"
                                        onClick={e => this.editProfile(e)}
                                    >
                                        <span className="d-none d-md-block">
                                            <img
                                                style={{marginRight: '0.5rem'}}
                                                width={24}
                                                height={24}
                                                alt="pm"
                                                src={editSvg}
                                            /> {commonStrings.edit_profile}
                                        </span>
                                        <span className="d-md-none">
                                            <img
                                                width={24}
                                                height={24}
                                                alt="pm"
                                                src={editSvg}
                                            /></span>
                                    </Button>
                                    }
                                </Col>
                            </Row>
                            }
                            {isMobile &&
                            <>
                                {this.renderMobileMenu()}
                            </>
                            }

                        </Row>
                    </Container>
                </div>
            </>
        );
    }

    renderMobileMenu() {
        return <UncontrolledDropdown nav>
            <DropdownToggle className="pr-0" nav>
                <Button
                    color="info"
                    href="#"
                    onClick={e => e.preventDefault()}
                >
                    {commonStrings.navigation.edit_resources}
                </Button>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow bg-default" right>
                <DropdownItem className="noti-title" header tag="div">
                    <h6 className="text-overflow m-0"></h6>
                </DropdownItem>
                <DropdownItem onClick={e => this.showClassTypes(e)} tag={Link}>
                    <img
                        style={{marginRight: '0.5rem'}}
                        width={24}
                        height={24}
                        alt="pm"
                        src={businessHelper.classIcon()}/>
                    <span className="text-white">{resourceStrings.class_types}</span>
                </DropdownItem>

                <DropdownItem onClick={e => this.showTicketTypes(e)} tag={Link}>
                    <img
                        style={{marginRight: '0.5rem'}}
                        width={24}
                        height={24}
                        alt="pm"
                        src={require("assets/img/icons/common/ticket_white.svg").default}
                    />
                    <span className="text-white">{resourceStrings.ticket_types}</span>
                </DropdownItem>

                <DropdownItem onClick={e => this.showTeachers(e)} tag={Link}>
                    <img
                        style={{marginRight: '0.5rem'}}
                        width={24}
                        height={24}
                        alt="pm"
                        src={businessHelper.teacherIcon()}
                    />
                    <span className="text-white">{resourceStrings.teachers}</span>
                </DropdownItem>

                <DropdownItem onClick={e => this.showRooms(e)} tag={Link}>
                    <img
                        style={{marginRight: '0.5rem'}}
                        width={24}
                        height={24}
                        alt="pm"
                        src={roomSvg}
                    />
                    <span className="text-white">{resourceStrings.rooms}</span>
                </DropdownItem>

                <DropdownItem divider/>
                <DropdownItem href="#pablo" onClick={e => this.editProfile(e)}>
                    <img
                        style={{marginRight: '0.5rem'}}
                        width={24}
                        height={24}
                        alt="pm"
                        src={editSvg}
                    /> <span className="text-white">{commonStrings.edit_profile}</span>
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        // studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        // alertStrings.setLanguage(loc);
    }
}

export default UserHeader;
